export const INTERNAL_ERROR = 'INTERNAL_ERROR';
export const AUTH_ERROR = 'AUTH_ERROR';
export const FORBIDDEN_ERROR = 'FORBIDDEN_ERROR';


